'use client'

import { useSalaryFilters } from '@/modules/salary/filters/use-salary-filters'
import { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useIsMobile } from '@/utils/screen'
import { FiltersMobile } from '@/modules/salary/filters/mobile/filters-mobile'
import { FiltersDesktop } from '@/modules/salary/filters/desktop/filters-desktop'
import { getFilterControlValues } from '@/modules/salary/filters/filter-utils'
import { SalaryFilterControls } from '@/modules/salary/types'
import { SalaryFilterParam } from '../constants'
import { SalaryFilterControl } from '../constants'
import { LoadingResults } from '@/modules/salary/salary-table-context'

export function SalaryFilters({
  isAuthenticated,
  countPublicInteraction,
}: {
  isAuthenticated: boolean
  countPublicInteraction?: () => void
}) {
  const form = useForm<
    Pick<
      SalaryFilterControls,
      | SalaryFilterControl.state
      | SalaryFilterControl.specialty
      | SalaryFilterControl.jobType
      | SalaryFilterControl.profession
    >
  >({
    defaultValues: {
      [SalaryFilterControl.state]: null,
      [SalaryFilterControl.specialty]: null,
      [SalaryFilterParam.jobType]: undefined,
      [SalaryFilterControl.profession]: '',
    },
  })
  const isMobile = useIsMobile(900)
  const { reset } = form
  const { salaryFilterControls, updateSalaryFilters, loadingResults } =
    useSalaryFilters({
      isAuthenticated,
      countPublicInteraction,
    })
  const isLoading = loadingResults === LoadingResults.Default
  useEffect(() => {
    // keeps the zustand store in sync w/ the form
    reset(getFilterControlValues(salaryFilterControls))
  }, [salaryFilterControls, reset])

  return (
    <FormProvider {...form}>
      {isMobile ? (
        <FiltersMobile
          isAuthenticated={isAuthenticated}
          filtersValues={salaryFilterControls || null}
          onApplyFilters={updateSalaryFilters}
          loading={isLoading}
        />
      ) : (
        <FiltersDesktop
          onApplyFilters={updateSalaryFilters}
          loading={isLoading}
          isAuthenticated={isAuthenticated}
        />
      )}
    </FormProvider>
  )
}
